import React from "react";
import "../theme/Administracion.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { TableAdministracionComunicados } from "../components/TableAdministracionComunicados";
import { authProvider } from "../context/authProvider";
import { useNavigate } from "react-router-dom";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPageComunicados = () => {
  const navigate = useNavigate();
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>

              <TableAdministracionComunicados />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
